// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "quote.proto" (syntax proto3)
// tslint:disable
// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "quote.proto" (syntax proto3)
// tslint:disable
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { WireType } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
// @generated message type with reflection information, may provide speed optimized methods
class StoredQuote$Type extends MessageType {
    constructor() {
        super("StoredQuote", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "price", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.description = "";
        message.price = 0;
        message.fieldMask = [];
        message.pageNumber = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string description */ 2:
                    message.description = reader.string();
                    break;
                case /* int32 price */ 3:
                    message.price = reader.int32();
                    break;
                case /* repeated string field_mask */ 4:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 5:
                    message.pageNumber = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string description = 2; */
        if (message.description !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.description);
        /* int32 price = 3; */
        if (message.price !== 0)
            writer.tag(3, WireType.Varint).int32(message.price);
        /* repeated string field_mask = 4; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 5; */
        if (message.pageNumber !== 0)
            writer.tag(5, WireType.Varint).int32(message.pageNumber);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message StoredQuote
 */
export const StoredQuote = new StoredQuote$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StoredQuoteList$Type extends MessageType {
    constructor() {
        super("StoredQuoteList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => StoredQuote },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated StoredQuote results */ 1:
                    message.results.push(StoredQuote.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated StoredQuote results = 1; */
        for (let i = 0; i < message.results.length; i++)
            StoredQuote.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message StoredQuoteList
 */
export const StoredQuoteList = new StoredQuoteList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QuoteDocument$Type extends MessageType {
    constructor() {
        super("QuoteDocument", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "document_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "property_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "reading_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "job_notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "prepared_by_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "display_business_name", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "include_job_notes", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "include_attachments", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 13, name: "quote_expire_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "created_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "valid_until_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "quote_sent_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 17, name: "signed_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "in_person", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 19, name: "block_line_items", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 20, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 21, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 22, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 23, name: "is_follow_up_job", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 24, name: "original_job_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 25, name: "discount", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 26, name: "discountcost", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 27, name: "lost_reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 28, name: "tax", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 29, name: "tax_cost", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 30, name: "quote_lost", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 31, name: "signature_override_note", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 32, name: "reminder_sent", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 33, name: "reminder_sent_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 34, name: "customer_viewed_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.documentId = 0;
        message.propertyId = 0;
        message.readingId = 0;
        message.eventId = 0;
        message.jobNotes = "";
        message.preparedById = 0;
        message.displayBusinessName = 0;
        message.includeJobNotes = 0;
        message.includeAttachments = 0;
        message.quoteExpireDate = "";
        message.createdDate = "";
        message.validUntilDate = "";
        message.quoteSentDate = "";
        message.signedDate = "";
        message.inPerson = 0;
        message.blockLineItems = 0;
        message.fieldMask = [];
        message.pageNumber = 0;
        message.withoutLimit = false;
        message.orderBy = "";
        message.orderDir = "";
        message.isFollowUpJob = false;
        message.originalJobNumber = 0;
        message.discount = "";
        message.discountcost = "";
        message.lostReason = "";
        message.tax = 0;
        message.taxCost = 0;
        message.quoteLost = false;
        message.signatureOverrideNote = "";
        message.reminderSent = false;
        message.reminderSentDate = "";
        message.customerViewedDate = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 document_id */ 2:
                    message.documentId = reader.int32();
                    break;
                case /* int32 property_id */ 3:
                    message.propertyId = reader.int32();
                    break;
                case /* int32 reading_id */ 4:
                    message.readingId = reader.int32();
                    break;
                case /* int32 event_id */ 5:
                    message.eventId = reader.int32();
                    break;
                case /* string job_notes */ 6:
                    message.jobNotes = reader.string();
                    break;
                case /* int32 prepared_by_id */ 9:
                    message.preparedById = reader.int32();
                    break;
                case /* int32 display_business_name */ 10:
                    message.displayBusinessName = reader.int32();
                    break;
                case /* int32 include_job_notes */ 11:
                    message.includeJobNotes = reader.int32();
                    break;
                case /* int32 include_attachments */ 12:
                    message.includeAttachments = reader.int32();
                    break;
                case /* string quote_expire_date */ 13:
                    message.quoteExpireDate = reader.string();
                    break;
                case /* string created_date */ 14:
                    message.createdDate = reader.string();
                    break;
                case /* string valid_until_date */ 15:
                    message.validUntilDate = reader.string();
                    break;
                case /* string quote_sent_date */ 16:
                    message.quoteSentDate = reader.string();
                    break;
                case /* string signed_date */ 17:
                    message.signedDate = reader.string();
                    break;
                case /* int32 in_person */ 18:
                    message.inPerson = reader.int32();
                    break;
                case /* int32 block_line_items */ 19:
                    message.blockLineItems = reader.int32();
                    break;
                case /* repeated string field_mask */ 7:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 8:
                    message.pageNumber = reader.int32();
                    break;
                case /* bool without_limit */ 20:
                    message.withoutLimit = reader.bool();
                    break;
                case /* string order_by */ 21:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 22:
                    message.orderDir = reader.string();
                    break;
                case /* bool is_follow_up_job */ 23:
                    message.isFollowUpJob = reader.bool();
                    break;
                case /* int32 original_job_number */ 24:
                    message.originalJobNumber = reader.int32();
                    break;
                case /* string discount */ 25:
                    message.discount = reader.string();
                    break;
                case /* string discountcost */ 26:
                    message.discountcost = reader.string();
                    break;
                case /* string lost_reason */ 27:
                    message.lostReason = reader.string();
                    break;
                case /* float tax */ 28:
                    message.tax = reader.float();
                    break;
                case /* float tax_cost */ 29:
                    message.taxCost = reader.float();
                    break;
                case /* bool quote_lost */ 30:
                    message.quoteLost = reader.bool();
                    break;
                case /* string signature_override_note = 31 [deprecated = true] */ 31:
                    message.signatureOverrideNote = reader.string();
                    break;
                case /* bool reminder_sent */ 32:
                    message.reminderSent = reader.bool();
                    break;
                case /* string reminder_sent_date */ 33:
                    message.reminderSentDate = reader.string();
                    break;
                case /* string customer_viewed_date */ 34:
                    message.customerViewedDate = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 document_id = 2; */
        if (message.documentId !== 0)
            writer.tag(2, WireType.Varint).int32(message.documentId);
        /* int32 property_id = 3; */
        if (message.propertyId !== 0)
            writer.tag(3, WireType.Varint).int32(message.propertyId);
        /* int32 reading_id = 4; */
        if (message.readingId !== 0)
            writer.tag(4, WireType.Varint).int32(message.readingId);
        /* int32 event_id = 5; */
        if (message.eventId !== 0)
            writer.tag(5, WireType.Varint).int32(message.eventId);
        /* string job_notes = 6; */
        if (message.jobNotes !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.jobNotes);
        /* repeated string field_mask = 7; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(7, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 8; */
        if (message.pageNumber !== 0)
            writer.tag(8, WireType.Varint).int32(message.pageNumber);
        /* int32 prepared_by_id = 9; */
        if (message.preparedById !== 0)
            writer.tag(9, WireType.Varint).int32(message.preparedById);
        /* int32 display_business_name = 10; */
        if (message.displayBusinessName !== 0)
            writer.tag(10, WireType.Varint).int32(message.displayBusinessName);
        /* int32 include_job_notes = 11; */
        if (message.includeJobNotes !== 0)
            writer.tag(11, WireType.Varint).int32(message.includeJobNotes);
        /* int32 include_attachments = 12; */
        if (message.includeAttachments !== 0)
            writer.tag(12, WireType.Varint).int32(message.includeAttachments);
        /* string quote_expire_date = 13; */
        if (message.quoteExpireDate !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.quoteExpireDate);
        /* string created_date = 14; */
        if (message.createdDate !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.createdDate);
        /* string valid_until_date = 15; */
        if (message.validUntilDate !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.validUntilDate);
        /* string quote_sent_date = 16; */
        if (message.quoteSentDate !== "")
            writer.tag(16, WireType.LengthDelimited).string(message.quoteSentDate);
        /* string signed_date = 17; */
        if (message.signedDate !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.signedDate);
        /* int32 in_person = 18; */
        if (message.inPerson !== 0)
            writer.tag(18, WireType.Varint).int32(message.inPerson);
        /* int32 block_line_items = 19; */
        if (message.blockLineItems !== 0)
            writer.tag(19, WireType.Varint).int32(message.blockLineItems);
        /* bool without_limit = 20; */
        if (message.withoutLimit !== false)
            writer.tag(20, WireType.Varint).bool(message.withoutLimit);
        /* string order_by = 21; */
        if (message.orderBy !== "")
            writer.tag(21, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 22; */
        if (message.orderDir !== "")
            writer.tag(22, WireType.LengthDelimited).string(message.orderDir);
        /* bool is_follow_up_job = 23; */
        if (message.isFollowUpJob !== false)
            writer.tag(23, WireType.Varint).bool(message.isFollowUpJob);
        /* int32 original_job_number = 24; */
        if (message.originalJobNumber !== 0)
            writer.tag(24, WireType.Varint).int32(message.originalJobNumber);
        /* string discount = 25; */
        if (message.discount !== "")
            writer.tag(25, WireType.LengthDelimited).string(message.discount);
        /* string discountcost = 26; */
        if (message.discountcost !== "")
            writer.tag(26, WireType.LengthDelimited).string(message.discountcost);
        /* string lost_reason = 27; */
        if (message.lostReason !== "")
            writer.tag(27, WireType.LengthDelimited).string(message.lostReason);
        /* float tax = 28; */
        if (message.tax !== 0)
            writer.tag(28, WireType.Bit32).float(message.tax);
        /* float tax_cost = 29; */
        if (message.taxCost !== 0)
            writer.tag(29, WireType.Bit32).float(message.taxCost);
        /* bool quote_lost = 30; */
        if (message.quoteLost !== false)
            writer.tag(30, WireType.Varint).bool(message.quoteLost);
        /* string signature_override_note = 31 [deprecated = true]; */
        if (message.signatureOverrideNote !== "")
            writer.tag(31, WireType.LengthDelimited).string(message.signatureOverrideNote);
        /* bool reminder_sent = 32; */
        if (message.reminderSent !== false)
            writer.tag(32, WireType.Varint).bool(message.reminderSent);
        /* string reminder_sent_date = 33; */
        if (message.reminderSentDate !== "")
            writer.tag(33, WireType.LengthDelimited).string(message.reminderSentDate);
        /* string customer_viewed_date = 34; */
        if (message.customerViewedDate !== "")
            writer.tag(34, WireType.LengthDelimited).string(message.customerViewedDate);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QuoteDocument
 */
export const QuoteDocument = new QuoteDocument$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QuoteDocumentList$Type extends MessageType {
    constructor() {
        super("QuoteDocumentList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => QuoteDocument },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated QuoteDocument results */ 1:
                    message.results.push(QuoteDocument.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated QuoteDocument results = 1; */
        for (let i = 0; i < message.results.length; i++)
            QuoteDocument.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QuoteDocumentList
 */
export const QuoteDocumentList = new QuoteDocumentList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QuoteLinePart$Type extends MessageType {
    constructor() {
        super("QuoteLinePart", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "quote_line_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "quote_part_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "quantity", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "markup", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "tax", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.quoteLineId = 0;
        message.quotePartId = 0;
        message.quantity = 0;
        message.markup = 0;
        message.tax = 0;
        message.fieldMask = [];
        message.pageNumber = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 quote_line_id */ 2:
                    message.quoteLineId = reader.int32();
                    break;
                case /* int32 quote_part_id */ 3:
                    message.quotePartId = reader.int32();
                    break;
                case /* double quantity */ 4:
                    message.quantity = reader.double();
                    break;
                case /* double markup */ 5:
                    message.markup = reader.double();
                    break;
                case /* double tax */ 6:
                    message.tax = reader.double();
                    break;
                case /* repeated string field_mask */ 7:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 8:
                    message.pageNumber = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 quote_line_id = 2; */
        if (message.quoteLineId !== 0)
            writer.tag(2, WireType.Varint).int32(message.quoteLineId);
        /* int32 quote_part_id = 3; */
        if (message.quotePartId !== 0)
            writer.tag(3, WireType.Varint).int32(message.quotePartId);
        /* double quantity = 4; */
        if (message.quantity !== 0)
            writer.tag(4, WireType.Bit64).double(message.quantity);
        /* double markup = 5; */
        if (message.markup !== 0)
            writer.tag(5, WireType.Bit64).double(message.markup);
        /* double tax = 6; */
        if (message.tax !== 0)
            writer.tag(6, WireType.Bit64).double(message.tax);
        /* repeated string field_mask = 7; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(7, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 8; */
        if (message.pageNumber !== 0)
            writer.tag(8, WireType.Varint).int32(message.pageNumber);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QuoteLinePart
 */
export const QuoteLinePart = new QuoteLinePart$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QuoteLinePartList$Type extends MessageType {
    constructor() {
        super("QuoteLinePartList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => QuoteLinePart },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated QuoteLinePart results */ 1:
                    message.results.push(QuoteLinePart.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated QuoteLinePart results = 1; */
        for (let i = 0; i < message.results.length; i++)
            QuoteLinePart.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QuoteLinePartList
 */
export const QuoteLinePartList = new QuoteLinePartList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Quote$Type extends MessageType {
    constructor() {
        super("Quote", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "line_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "readings_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "price", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "document_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.lineId = 0;
        message.readingsId = 0;
        message.price = 0;
        message.documentId = 0;
        message.fieldMask = [];
        message.pageNumber = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 line_id */ 2:
                    message.lineId = reader.int32();
                    break;
                case /* int32 readings_id */ 3:
                    message.readingsId = reader.int32();
                    break;
                case /* double price */ 4:
                    message.price = reader.double();
                    break;
                case /* int32 document_id */ 5:
                    message.documentId = reader.int32();
                    break;
                case /* repeated string field_mask */ 6:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 7:
                    message.pageNumber = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 line_id = 2; */
        if (message.lineId !== 0)
            writer.tag(2, WireType.Varint).int32(message.lineId);
        /* int32 readings_id = 3; */
        if (message.readingsId !== 0)
            writer.tag(3, WireType.Varint).int32(message.readingsId);
        /* double price = 4; */
        if (message.price !== 0)
            writer.tag(4, WireType.Bit64).double(message.price);
        /* int32 document_id = 5; */
        if (message.documentId !== 0)
            writer.tag(5, WireType.Varint).int32(message.documentId);
        /* repeated string field_mask = 6; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 7; */
        if (message.pageNumber !== 0)
            writer.tag(7, WireType.Varint).int32(message.pageNumber);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message Quote
 */
export const Quote = new Quote$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QuoteList$Type extends MessageType {
    constructor() {
        super("QuoteList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Quote },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated Quote results */ 1:
                    message.results.push(Quote.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated Quote results = 1; */
        for (let i = 0; i < message.results.length; i++)
            Quote.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QuoteList
 */
export const QuoteList = new QuoteList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QuoteUsed$Type extends MessageType {
    constructor() {
        super("QuoteUsed", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "services_rendered_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "quote_line_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "quantity", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "quoted_price", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "billable", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "lmpc", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "invoice_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "include_in_invoice", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 12, name: "services_rendered_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 14, name: "direct_event_association_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 15, name: "direct_event_association_department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 16, name: "sort_order", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 17, name: "qb_item_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.servicesRenderedId = 0;
        message.quoteLineId = 0;
        message.quantity = 0;
        message.quotedPrice = 0;
        message.billable = 0;
        message.lmpc = 0;
        message.fieldMask = [];
        message.pageNumber = 0;
        message.invoiceId = 0;
        message.includeInInvoice = false;
        message.servicesRenderedList = "";
        message.withoutLimit = false;
        message.directEventAssociationId = 0;
        message.directEventAssociationDepartmentId = 0;
        message.sortOrder = 0;
        message.qbItemType = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 services_rendered_id */ 2:
                    message.servicesRenderedId = reader.int32();
                    break;
                case /* int32 quote_line_id */ 3:
                    message.quoteLineId = reader.int32();
                    break;
                case /* double quantity */ 4:
                    message.quantity = reader.double();
                    break;
                case /* double quoted_price */ 5:
                    message.quotedPrice = reader.double();
                    break;
                case /* int32 billable */ 6:
                    message.billable = reader.int32();
                    break;
                case /* int32 lmpc */ 7:
                    message.lmpc = reader.int32();
                    break;
                case /* repeated string field_mask */ 8:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 9:
                    message.pageNumber = reader.int32();
                    break;
                case /* int32 invoice_id */ 10:
                    message.invoiceId = reader.int32();
                    break;
                case /* bool include_in_invoice */ 11:
                    message.includeInInvoice = reader.bool();
                    break;
                case /* string services_rendered_list */ 12:
                    message.servicesRenderedList = reader.string();
                    break;
                case /* bool without_limit */ 13:
                    message.withoutLimit = reader.bool();
                    break;
                case /* int32 direct_event_association_id */ 14:
                    message.directEventAssociationId = reader.int32();
                    break;
                case /* int32 direct_event_association_department_id */ 15:
                    message.directEventAssociationDepartmentId = reader.int32();
                    break;
                case /* int32 sort_order */ 16:
                    message.sortOrder = reader.int32();
                    break;
                case /* string qb_item_type */ 17:
                    message.qbItemType = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 services_rendered_id = 2; */
        if (message.servicesRenderedId !== 0)
            writer.tag(2, WireType.Varint).int32(message.servicesRenderedId);
        /* int32 quote_line_id = 3; */
        if (message.quoteLineId !== 0)
            writer.tag(3, WireType.Varint).int32(message.quoteLineId);
        /* double quantity = 4; */
        if (message.quantity !== 0)
            writer.tag(4, WireType.Bit64).double(message.quantity);
        /* double quoted_price = 5; */
        if (message.quotedPrice !== 0)
            writer.tag(5, WireType.Bit64).double(message.quotedPrice);
        /* int32 billable = 6; */
        if (message.billable !== 0)
            writer.tag(6, WireType.Varint).int32(message.billable);
        /* int32 lmpc = 7; */
        if (message.lmpc !== 0)
            writer.tag(7, WireType.Varint).int32(message.lmpc);
        /* repeated string field_mask = 8; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(8, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 9; */
        if (message.pageNumber !== 0)
            writer.tag(9, WireType.Varint).int32(message.pageNumber);
        /* int32 invoice_id = 10; */
        if (message.invoiceId !== 0)
            writer.tag(10, WireType.Varint).int32(message.invoiceId);
        /* bool include_in_invoice = 11; */
        if (message.includeInInvoice !== false)
            writer.tag(11, WireType.Varint).bool(message.includeInInvoice);
        /* string services_rendered_list = 12; */
        if (message.servicesRenderedList !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.servicesRenderedList);
        /* bool without_limit = 13; */
        if (message.withoutLimit !== false)
            writer.tag(13, WireType.Varint).bool(message.withoutLimit);
        /* int32 direct_event_association_id = 14; */
        if (message.directEventAssociationId !== 0)
            writer.tag(14, WireType.Varint).int32(message.directEventAssociationId);
        /* int32 direct_event_association_department_id = 15; */
        if (message.directEventAssociationDepartmentId !== 0)
            writer.tag(15, WireType.Varint).int32(message.directEventAssociationDepartmentId);
        /* int32 sort_order = 16; */
        if (message.sortOrder !== 0)
            writer.tag(16, WireType.Varint).int32(message.sortOrder);
        /* string qb_item_type = 17; */
        if (message.qbItemType !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.qbItemType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QuoteUsed
 */
export const QuoteUsed = new QuoteUsed$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QuoteUsedList$Type extends MessageType {
    constructor() {
        super("QuoteUsedList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => QuoteUsed },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated QuoteUsed results */ 1:
                    message.results.push(QuoteUsed.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated QuoteUsed results = 1; */
        for (let i = 0; i < message.results.length; i++)
            QuoteUsed.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QuoteUsedList
 */
export const QuoteUsedList = new QuoteUsedList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QuotePart$Type extends MessageType {
    constructor() {
        super("QuotePart", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "vendor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "cost", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "availability", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.description = "";
        message.vendor = "";
        message.cost = 0;
        message.availability = 0;
        message.fieldMask = [];
        message.pageNumber = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string description */ 2:
                    message.description = reader.string();
                    break;
                case /* string vendor */ 3:
                    message.vendor = reader.string();
                    break;
                case /* double cost */ 4:
                    message.cost = reader.double();
                    break;
                case /* int32 availability */ 5:
                    message.availability = reader.int32();
                    break;
                case /* repeated string field_mask */ 6:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 7:
                    message.pageNumber = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string description = 2; */
        if (message.description !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.description);
        /* string vendor = 3; */
        if (message.vendor !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.vendor);
        /* double cost = 4; */
        if (message.cost !== 0)
            writer.tag(4, WireType.Bit64).double(message.cost);
        /* int32 availability = 5; */
        if (message.availability !== 0)
            writer.tag(5, WireType.Varint).int32(message.availability);
        /* repeated string field_mask = 6; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 7; */
        if (message.pageNumber !== 0)
            writer.tag(7, WireType.Varint).int32(message.pageNumber);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QuotePart
 */
export const QuotePart = new QuotePart$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QuotePartList$Type extends MessageType {
    constructor() {
        super("QuotePartList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => QuotePart },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated QuotePart results */ 1:
                    message.results.push(QuotePart.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated QuotePart results = 1; */
        for (let i = 0; i < message.results.length; i++)
            QuotePart.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QuotePartList
 */
export const QuotePartList = new QuotePartList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QuoteLine$Type extends MessageType {
    constructor() {
        super("QuoteLine", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "quote_type", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "labor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "refrigerant_lbs", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "adjustment", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "is_flatrate", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "diagnosis", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "warranty", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "quote_reference", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "job_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "quote_status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 13, name: "for_user", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 14, name: "item_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 15, name: "photo_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 16, name: "is_active", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 23, name: "quoted_quantity", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 24, name: "sort_order", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 17, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 19, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 20, name: "departments", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 21, name: "include_proposal_photos", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 22, name: "photos", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => QuotePhoto },
            { no: 25, name: "quote_document_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 26, name: "exclude_invoice_discount", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 27, name: "quote_line_id_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.quoteType = 0;
        message.labor = "";
        message.refrigerantLbs = "";
        message.adjustment = "";
        message.isFlatrate = "";
        message.description = "";
        message.diagnosis = "";
        message.warranty = 0;
        message.quoteReference = "";
        message.jobNumber = "";
        message.quoteStatus = 0;
        message.forUser = 0;
        message.itemId = 0;
        message.photoId = 0;
        message.isActive = 0;
        message.quotedQuantity = 0;
        message.sortOrder = 0;
        message.fieldMask = [];
        message.withoutLimit = false;
        message.pageNumber = 0;
        message.departments = "";
        message.includeProposalPhotos = false;
        message.photos = [];
        message.quoteDocumentId = 0;
        message.excludeInvoiceDiscount = 0;
        message.quoteLineIdList = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 quote_type */ 2:
                    message.quoteType = reader.int32();
                    break;
                case /* string labor */ 3:
                    message.labor = reader.string();
                    break;
                case /* string refrigerant_lbs */ 4:
                    message.refrigerantLbs = reader.string();
                    break;
                case /* string adjustment */ 5:
                    message.adjustment = reader.string();
                    break;
                case /* string is_flatrate */ 6:
                    message.isFlatrate = reader.string();
                    break;
                case /* string description */ 7:
                    message.description = reader.string();
                    break;
                case /* string diagnosis */ 8:
                    message.diagnosis = reader.string();
                    break;
                case /* int32 warranty */ 9:
                    message.warranty = reader.int32();
                    break;
                case /* string quote_reference */ 10:
                    message.quoteReference = reader.string();
                    break;
                case /* string job_number */ 11:
                    message.jobNumber = reader.string();
                    break;
                case /* int32 quote_status */ 12:
                    message.quoteStatus = reader.int32();
                    break;
                case /* int32 for_user */ 13:
                    message.forUser = reader.int32();
                    break;
                case /* int32 item_id */ 14:
                    message.itemId = reader.int32();
                    break;
                case /* int32 photo_id */ 15:
                    message.photoId = reader.int32();
                    break;
                case /* int32 is_active */ 16:
                    message.isActive = reader.int32();
                    break;
                case /* double quoted_quantity */ 23:
                    message.quotedQuantity = reader.double();
                    break;
                case /* int32 sort_order */ 24:
                    message.sortOrder = reader.int32();
                    break;
                case /* repeated string field_mask */ 17:
                    message.fieldMask.push(reader.string());
                    break;
                case /* bool without_limit */ 18:
                    message.withoutLimit = reader.bool();
                    break;
                case /* int32 page_number */ 19:
                    message.pageNumber = reader.int32();
                    break;
                case /* string departments */ 20:
                    message.departments = reader.string();
                    break;
                case /* bool include_proposal_photos */ 21:
                    message.includeProposalPhotos = reader.bool();
                    break;
                case /* repeated QuotePhoto photos */ 22:
                    message.photos.push(QuotePhoto.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 quote_document_id */ 25:
                    message.quoteDocumentId = reader.int32();
                    break;
                case /* int32 exclude_invoice_discount */ 26:
                    message.excludeInvoiceDiscount = reader.int32();
                    break;
                case /* string quote_line_id_list */ 27:
                    message.quoteLineIdList = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 quote_type = 2; */
        if (message.quoteType !== 0)
            writer.tag(2, WireType.Varint).int32(message.quoteType);
        /* string labor = 3; */
        if (message.labor !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.labor);
        /* string refrigerant_lbs = 4; */
        if (message.refrigerantLbs !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.refrigerantLbs);
        /* string adjustment = 5; */
        if (message.adjustment !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.adjustment);
        /* string is_flatrate = 6; */
        if (message.isFlatrate !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.isFlatrate);
        /* string description = 7; */
        if (message.description !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.description);
        /* string diagnosis = 8; */
        if (message.diagnosis !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.diagnosis);
        /* int32 warranty = 9; */
        if (message.warranty !== 0)
            writer.tag(9, WireType.Varint).int32(message.warranty);
        /* string quote_reference = 10; */
        if (message.quoteReference !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.quoteReference);
        /* string job_number = 11; */
        if (message.jobNumber !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.jobNumber);
        /* int32 quote_status = 12; */
        if (message.quoteStatus !== 0)
            writer.tag(12, WireType.Varint).int32(message.quoteStatus);
        /* int32 for_user = 13; */
        if (message.forUser !== 0)
            writer.tag(13, WireType.Varint).int32(message.forUser);
        /* int32 item_id = 14; */
        if (message.itemId !== 0)
            writer.tag(14, WireType.Varint).int32(message.itemId);
        /* int32 photo_id = 15; */
        if (message.photoId !== 0)
            writer.tag(15, WireType.Varint).int32(message.photoId);
        /* int32 is_active = 16; */
        if (message.isActive !== 0)
            writer.tag(16, WireType.Varint).int32(message.isActive);
        /* repeated string field_mask = 17; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(17, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* bool without_limit = 18; */
        if (message.withoutLimit !== false)
            writer.tag(18, WireType.Varint).bool(message.withoutLimit);
        /* int32 page_number = 19; */
        if (message.pageNumber !== 0)
            writer.tag(19, WireType.Varint).int32(message.pageNumber);
        /* string departments = 20; */
        if (message.departments !== "")
            writer.tag(20, WireType.LengthDelimited).string(message.departments);
        /* bool include_proposal_photos = 21; */
        if (message.includeProposalPhotos !== false)
            writer.tag(21, WireType.Varint).bool(message.includeProposalPhotos);
        /* repeated QuotePhoto photos = 22; */
        for (let i = 0; i < message.photos.length; i++)
            QuotePhoto.internalBinaryWrite(message.photos[i], writer.tag(22, WireType.LengthDelimited).fork(), options).join();
        /* double quoted_quantity = 23; */
        if (message.quotedQuantity !== 0)
            writer.tag(23, WireType.Bit64).double(message.quotedQuantity);
        /* int32 sort_order = 24; */
        if (message.sortOrder !== 0)
            writer.tag(24, WireType.Varint).int32(message.sortOrder);
        /* int32 quote_document_id = 25; */
        if (message.quoteDocumentId !== 0)
            writer.tag(25, WireType.Varint).int32(message.quoteDocumentId);
        /* int32 exclude_invoice_discount = 26; */
        if (message.excludeInvoiceDiscount !== 0)
            writer.tag(26, WireType.Varint).int32(message.excludeInvoiceDiscount);
        /* string quote_line_id_list = 27; */
        if (message.quoteLineIdList !== "")
            writer.tag(27, WireType.LengthDelimited).string(message.quoteLineIdList);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QuoteLine
 */
export const QuoteLine = new QuoteLine$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QuoteLineList$Type extends MessageType {
    constructor() {
        super("QuoteLineList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => QuoteLine },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated QuoteLine results */ 1:
                    message.results.push(QuoteLine.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated QuoteLine results = 1; */
        for (let i = 0; i < message.results.length; i++)
            QuoteLine.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QuoteLineList
 */
export const QuoteLineList = new QuoteLineList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QuotePhoto$Type extends MessageType {
    constructor() {
        super("QuotePhoto", [
            { no: 1, name: "photo_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "file_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "quote_line_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "quote_part_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "is_active", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "file_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "file_bucket", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "download_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "quote_line_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.photoId = 0;
        message.fileId = 0;
        message.quoteLineId = 0;
        message.quotePartId = 0;
        message.isActive = 0;
        message.fieldMask = [];
        message.pageNumber = 0;
        message.withoutLimit = false;
        message.fileName = "";
        message.fileBucket = "";
        message.downloadUrl = "";
        message.quoteLineList = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 photo_id */ 1:
                    message.photoId = reader.int32();
                    break;
                case /* int32 file_id */ 2:
                    message.fileId = reader.int32();
                    break;
                case /* int32 quote_line_id */ 3:
                    message.quoteLineId = reader.int32();
                    break;
                case /* int32 quote_part_id */ 4:
                    message.quotePartId = reader.int32();
                    break;
                case /* int32 is_active */ 5:
                    message.isActive = reader.int32();
                    break;
                case /* repeated string field_mask */ 6:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 7:
                    message.pageNumber = reader.int32();
                    break;
                case /* bool without_limit */ 8:
                    message.withoutLimit = reader.bool();
                    break;
                case /* string file_name */ 9:
                    message.fileName = reader.string();
                    break;
                case /* string file_bucket */ 10:
                    message.fileBucket = reader.string();
                    break;
                case /* string download_url */ 11:
                    message.downloadUrl = reader.string();
                    break;
                case /* string quote_line_list */ 12:
                    message.quoteLineList = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 photo_id = 1; */
        if (message.photoId !== 0)
            writer.tag(1, WireType.Varint).int32(message.photoId);
        /* int32 file_id = 2; */
        if (message.fileId !== 0)
            writer.tag(2, WireType.Varint).int32(message.fileId);
        /* int32 quote_line_id = 3; */
        if (message.quoteLineId !== 0)
            writer.tag(3, WireType.Varint).int32(message.quoteLineId);
        /* int32 quote_part_id = 4; */
        if (message.quotePartId !== 0)
            writer.tag(4, WireType.Varint).int32(message.quotePartId);
        /* int32 is_active = 5; */
        if (message.isActive !== 0)
            writer.tag(5, WireType.Varint).int32(message.isActive);
        /* repeated string field_mask = 6; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 7; */
        if (message.pageNumber !== 0)
            writer.tag(7, WireType.Varint).int32(message.pageNumber);
        /* bool without_limit = 8; */
        if (message.withoutLimit !== false)
            writer.tag(8, WireType.Varint).bool(message.withoutLimit);
        /* string file_name = 9; */
        if (message.fileName !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.fileName);
        /* string file_bucket = 10; */
        if (message.fileBucket !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.fileBucket);
        /* string download_url = 11; */
        if (message.downloadUrl !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.downloadUrl);
        /* string quote_line_list = 12; */
        if (message.quoteLineList !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.quoteLineList);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QuotePhoto
 */
export const QuotePhoto = new QuotePhoto$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QuoteUsedPhoto$Type extends MessageType {
    constructor() {
        super("QuoteUsedPhoto", [
            { no: 1, name: "photo_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "file_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "quote_used_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "quote_part_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "is_active", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "file_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "file_bucket", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "download_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "quote_used_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.photoId = 0;
        message.fileId = 0;
        message.quoteUsedId = 0;
        message.quotePartId = 0;
        message.isActive = 0;
        message.fieldMask = [];
        message.pageNumber = 0;
        message.withoutLimit = false;
        message.fileName = "";
        message.fileBucket = "";
        message.downloadUrl = "";
        message.quoteUsedList = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 photo_id */ 1:
                    message.photoId = reader.int32();
                    break;
                case /* int32 file_id */ 2:
                    message.fileId = reader.int32();
                    break;
                case /* int32 quote_used_id */ 3:
                    message.quoteUsedId = reader.int32();
                    break;
                case /* int32 quote_part_id */ 4:
                    message.quotePartId = reader.int32();
                    break;
                case /* int32 is_active */ 5:
                    message.isActive = reader.int32();
                    break;
                case /* repeated string field_mask */ 6:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 7:
                    message.pageNumber = reader.int32();
                    break;
                case /* bool without_limit */ 8:
                    message.withoutLimit = reader.bool();
                    break;
                case /* string file_name */ 9:
                    message.fileName = reader.string();
                    break;
                case /* string file_bucket */ 10:
                    message.fileBucket = reader.string();
                    break;
                case /* string download_url */ 11:
                    message.downloadUrl = reader.string();
                    break;
                case /* string quote_used_list */ 12:
                    message.quoteUsedList = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 photo_id = 1; */
        if (message.photoId !== 0)
            writer.tag(1, WireType.Varint).int32(message.photoId);
        /* int32 file_id = 2; */
        if (message.fileId !== 0)
            writer.tag(2, WireType.Varint).int32(message.fileId);
        /* int32 quote_used_id = 3; */
        if (message.quoteUsedId !== 0)
            writer.tag(3, WireType.Varint).int32(message.quoteUsedId);
        /* int32 quote_part_id = 4; */
        if (message.quotePartId !== 0)
            writer.tag(4, WireType.Varint).int32(message.quotePartId);
        /* int32 is_active = 5; */
        if (message.isActive !== 0)
            writer.tag(5, WireType.Varint).int32(message.isActive);
        /* repeated string field_mask = 6; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 7; */
        if (message.pageNumber !== 0)
            writer.tag(7, WireType.Varint).int32(message.pageNumber);
        /* bool without_limit = 8; */
        if (message.withoutLimit !== false)
            writer.tag(8, WireType.Varint).bool(message.withoutLimit);
        /* string file_name = 9; */
        if (message.fileName !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.fileName);
        /* string file_bucket = 10; */
        if (message.fileBucket !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.fileBucket);
        /* string download_url = 11; */
        if (message.downloadUrl !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.downloadUrl);
        /* string quote_used_list = 12; */
        if (message.quoteUsedList !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.quoteUsedList);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QuoteUsedPhoto
 */
export const QuoteUsedPhoto = new QuoteUsedPhoto$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QuotePhotoList$Type extends MessageType {
    constructor() {
        super("QuotePhotoList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => QuotePhoto },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated QuotePhoto results */ 1:
                    message.results.push(QuotePhoto.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated QuotePhoto results = 1; */
        for (let i = 0; i < message.results.length; i++)
            QuotePhoto.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QuotePhotoList
 */
export const QuotePhotoList = new QuotePhotoList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QuoteUsedPhotoList$Type extends MessageType {
    constructor() {
        super("QuoteUsedPhotoList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => QuoteUsedPhoto },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated QuoteUsedPhoto results */ 1:
                    message.results.push(QuoteUsedPhoto.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated QuoteUsedPhoto results = 1; */
        for (let i = 0; i < message.results.length; i++)
            QuoteUsedPhoto.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QuoteUsedPhotoList
 */
export const QuoteUsedPhotoList = new QuoteUsedPhotoList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProposalMetricsRequest$Type extends MessageType {
    constructor() {
        super("ProposalMetricsRequest", [
            { no: 1, name: "date_start", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "date_end", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "prepared_by_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "lost_threshold_days", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "department_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "prepared_by_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "tech_user_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "assigned_admin_user_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "sector", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "intake_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "is_lmpc_filter", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.dateStart = "";
        message.dateEnd = "";
        message.departmentId = 0;
        message.preparedById = 0;
        message.lostThresholdDays = 0;
        message.departmentIds = [];
        message.preparedByIds = [];
        message.techUserIds = [];
        message.assignedAdminUserIds = [];
        message.sector = 0;
        message.intakeType = "";
        message.isLmpcFilter = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string date_start */ 1:
                    message.dateStart = reader.string();
                    break;
                case /* string date_end */ 2:
                    message.dateEnd = reader.string();
                    break;
                case /* int32 department_id */ 3:
                    message.departmentId = reader.int32();
                    break;
                case /* int32 prepared_by_id */ 4:
                    message.preparedById = reader.int32();
                    break;
                case /* int32 lost_threshold_days */ 5:
                    message.lostThresholdDays = reader.int32();
                    break;
                case /* repeated int32 department_ids */ 6:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.departmentIds.push(reader.int32());
                    else
                        message.departmentIds.push(reader.int32());
                    break;
                case /* repeated int32 prepared_by_ids */ 7:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.preparedByIds.push(reader.int32());
                    else
                        message.preparedByIds.push(reader.int32());
                    break;
                case /* repeated int32 tech_user_ids */ 8:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.techUserIds.push(reader.int32());
                    else
                        message.techUserIds.push(reader.int32());
                    break;
                case /* repeated int32 assigned_admin_user_ids */ 9:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.assignedAdminUserIds.push(reader.int32());
                    else
                        message.assignedAdminUserIds.push(reader.int32());
                    break;
                case /* int32 sector */ 10:
                    message.sector = reader.int32();
                    break;
                case /* string intake_type */ 11:
                    message.intakeType = reader.string();
                    break;
                case /* string is_lmpc_filter */ 12:
                    message.isLmpcFilter = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string date_start = 1; */
        if (message.dateStart !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.dateStart);
        /* string date_end = 2; */
        if (message.dateEnd !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.dateEnd);
        /* int32 department_id = 3; */
        if (message.departmentId !== 0)
            writer.tag(3, WireType.Varint).int32(message.departmentId);
        /* int32 prepared_by_id = 4; */
        if (message.preparedById !== 0)
            writer.tag(4, WireType.Varint).int32(message.preparedById);
        /* int32 lost_threshold_days = 5; */
        if (message.lostThresholdDays !== 0)
            writer.tag(5, WireType.Varint).int32(message.lostThresholdDays);
        /* repeated int32 department_ids = 6; */
        if (message.departmentIds.length) {
            writer.tag(6, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.departmentIds.length; i++)
                writer.int32(message.departmentIds[i]);
            writer.join();
        }
        /* repeated int32 prepared_by_ids = 7; */
        if (message.preparedByIds.length) {
            writer.tag(7, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.preparedByIds.length; i++)
                writer.int32(message.preparedByIds[i]);
            writer.join();
        }
        /* repeated int32 tech_user_ids = 8; */
        if (message.techUserIds.length) {
            writer.tag(8, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.techUserIds.length; i++)
                writer.int32(message.techUserIds[i]);
            writer.join();
        }
        /* repeated int32 assigned_admin_user_ids = 9; */
        if (message.assignedAdminUserIds.length) {
            writer.tag(9, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.assignedAdminUserIds.length; i++)
                writer.int32(message.assignedAdminUserIds[i]);
            writer.join();
        }
        /* int32 sector = 10; */
        if (message.sector !== 0)
            writer.tag(10, WireType.Varint).int32(message.sector);
        /* string intake_type = 11; */
        if (message.intakeType !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.intakeType);
        /* string is_lmpc_filter = 12; */
        if (message.isLmpcFilter !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.isLmpcFilter);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProposalMetricsRequest
 */
export const ProposalMetricsRequest = new ProposalMetricsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProposalMetricsResponse$Type extends MessageType {
    constructor() {
        super("ProposalMetricsResponse", [
            { no: 1, name: "total_proposals", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "total_amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "won_amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "lost_amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 11, name: "expired_amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "open_amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "conversion_rate", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "won_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "lost_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "expired_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "open_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "jobs_needing_quotes_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 13, name: "pending_approval_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 14, name: "part_on_order_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 15, name: "pend_sched_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.totalProposals = 0;
        message.totalAmount = 0;
        message.wonAmount = 0;
        message.lostAmount = 0;
        message.expiredAmount = 0;
        message.openAmount = 0;
        message.conversionRate = 0;
        message.wonCount = 0;
        message.lostCount = 0;
        message.expiredCount = 0;
        message.openCount = 0;
        message.jobsNeedingQuotesCount = 0;
        message.pendingApprovalCount = 0;
        message.partOnOrderCount = 0;
        message.pendSchedCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 total_proposals */ 1:
                    message.totalProposals = reader.int32();
                    break;
                case /* double total_amount */ 2:
                    message.totalAmount = reader.double();
                    break;
                case /* double won_amount */ 3:
                    message.wonAmount = reader.double();
                    break;
                case /* double lost_amount */ 4:
                    message.lostAmount = reader.double();
                    break;
                case /* double expired_amount */ 11:
                    message.expiredAmount = reader.double();
                    break;
                case /* double open_amount */ 5:
                    message.openAmount = reader.double();
                    break;
                case /* double conversion_rate */ 6:
                    message.conversionRate = reader.double();
                    break;
                case /* int32 won_count */ 7:
                    message.wonCount = reader.int32();
                    break;
                case /* int32 lost_count */ 8:
                    message.lostCount = reader.int32();
                    break;
                case /* int32 expired_count */ 12:
                    message.expiredCount = reader.int32();
                    break;
                case /* int32 open_count */ 9:
                    message.openCount = reader.int32();
                    break;
                case /* int32 jobs_needing_quotes_count */ 10:
                    message.jobsNeedingQuotesCount = reader.int32();
                    break;
                case /* int32 pending_approval_count */ 13:
                    message.pendingApprovalCount = reader.int32();
                    break;
                case /* int32 part_on_order_count */ 14:
                    message.partOnOrderCount = reader.int32();
                    break;
                case /* int32 pend_sched_count */ 15:
                    message.pendSchedCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 total_proposals = 1; */
        if (message.totalProposals !== 0)
            writer.tag(1, WireType.Varint).int32(message.totalProposals);
        /* double total_amount = 2; */
        if (message.totalAmount !== 0)
            writer.tag(2, WireType.Bit64).double(message.totalAmount);
        /* double won_amount = 3; */
        if (message.wonAmount !== 0)
            writer.tag(3, WireType.Bit64).double(message.wonAmount);
        /* double lost_amount = 4; */
        if (message.lostAmount !== 0)
            writer.tag(4, WireType.Bit64).double(message.lostAmount);
        /* double open_amount = 5; */
        if (message.openAmount !== 0)
            writer.tag(5, WireType.Bit64).double(message.openAmount);
        /* double conversion_rate = 6; */
        if (message.conversionRate !== 0)
            writer.tag(6, WireType.Bit64).double(message.conversionRate);
        /* int32 won_count = 7; */
        if (message.wonCount !== 0)
            writer.tag(7, WireType.Varint).int32(message.wonCount);
        /* int32 lost_count = 8; */
        if (message.lostCount !== 0)
            writer.tag(8, WireType.Varint).int32(message.lostCount);
        /* int32 open_count = 9; */
        if (message.openCount !== 0)
            writer.tag(9, WireType.Varint).int32(message.openCount);
        /* int32 jobs_needing_quotes_count = 10; */
        if (message.jobsNeedingQuotesCount !== 0)
            writer.tag(10, WireType.Varint).int32(message.jobsNeedingQuotesCount);
        /* double expired_amount = 11; */
        if (message.expiredAmount !== 0)
            writer.tag(11, WireType.Bit64).double(message.expiredAmount);
        /* int32 expired_count = 12; */
        if (message.expiredCount !== 0)
            writer.tag(12, WireType.Varint).int32(message.expiredCount);
        /* int32 pending_approval_count = 13; */
        if (message.pendingApprovalCount !== 0)
            writer.tag(13, WireType.Varint).int32(message.pendingApprovalCount);
        /* int32 part_on_order_count = 14; */
        if (message.partOnOrderCount !== 0)
            writer.tag(14, WireType.Varint).int32(message.partOnOrderCount);
        /* int32 pend_sched_count = 15; */
        if (message.pendSchedCount !== 0)
            writer.tag(15, WireType.Varint).int32(message.pendSchedCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProposalMetricsResponse
 */
export const ProposalMetricsResponse = new ProposalMetricsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProposalsByStatusRequest$Type extends MessageType {
    constructor() {
        super("ProposalsByStatusRequest", [
            { no: 1, name: "date_start", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "date_end", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "prepared_by_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "lost_threshold_days", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "intake_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "is_lmpc_filter", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "tech_user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "priority_sort", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 13, name: "department_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 5 /*ScalarType.INT32*/ },
            { no: 14, name: "prepared_by_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 5 /*ScalarType.INT32*/ },
            { no: 15, name: "tech_user_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 5 /*ScalarType.INT32*/ },
            { no: 16, name: "assigned_admin_user_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 5 /*ScalarType.INT32*/ },
            { no: 17, name: "sector", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 18, name: "search", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 19, name: "job_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.dateStart = "";
        message.dateEnd = "";
        message.departmentId = 0;
        message.preparedById = 0;
        message.lostThresholdDays = 0;
        message.status = "";
        message.pageNumber = 0;
        message.pageSize = 0;
        message.intakeType = "";
        message.isLmpcFilter = "";
        message.techUserId = 0;
        message.prioritySort = false;
        message.departmentIds = [];
        message.preparedByIds = [];
        message.techUserIds = [];
        message.assignedAdminUserIds = [];
        message.sector = 0;
        message.search = "";
        message.jobStatus = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string date_start */ 1:
                    message.dateStart = reader.string();
                    break;
                case /* string date_end */ 2:
                    message.dateEnd = reader.string();
                    break;
                case /* int32 department_id */ 3:
                    message.departmentId = reader.int32();
                    break;
                case /* int32 prepared_by_id */ 4:
                    message.preparedById = reader.int32();
                    break;
                case /* int32 lost_threshold_days */ 5:
                    message.lostThresholdDays = reader.int32();
                    break;
                case /* string status */ 6:
                    message.status = reader.string();
                    break;
                case /* int32 page_number */ 7:
                    message.pageNumber = reader.int32();
                    break;
                case /* int32 page_size */ 8:
                    message.pageSize = reader.int32();
                    break;
                case /* string intake_type */ 9:
                    message.intakeType = reader.string();
                    break;
                case /* string is_lmpc_filter */ 10:
                    message.isLmpcFilter = reader.string();
                    break;
                case /* int32 tech_user_id */ 11:
                    message.techUserId = reader.int32();
                    break;
                case /* bool priority_sort */ 12:
                    message.prioritySort = reader.bool();
                    break;
                case /* repeated int32 department_ids */ 13:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.departmentIds.push(reader.int32());
                    else
                        message.departmentIds.push(reader.int32());
                    break;
                case /* repeated int32 prepared_by_ids */ 14:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.preparedByIds.push(reader.int32());
                    else
                        message.preparedByIds.push(reader.int32());
                    break;
                case /* repeated int32 tech_user_ids */ 15:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.techUserIds.push(reader.int32());
                    else
                        message.techUserIds.push(reader.int32());
                    break;
                case /* repeated int32 assigned_admin_user_ids */ 16:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.assignedAdminUserIds.push(reader.int32());
                    else
                        message.assignedAdminUserIds.push(reader.int32());
                    break;
                case /* int32 sector */ 17:
                    message.sector = reader.int32();
                    break;
                case /* string search */ 18:
                    message.search = reader.string();
                    break;
                case /* string job_status */ 19:
                    message.jobStatus = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string date_start = 1; */
        if (message.dateStart !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.dateStart);
        /* string date_end = 2; */
        if (message.dateEnd !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.dateEnd);
        /* int32 department_id = 3; */
        if (message.departmentId !== 0)
            writer.tag(3, WireType.Varint).int32(message.departmentId);
        /* int32 prepared_by_id = 4; */
        if (message.preparedById !== 0)
            writer.tag(4, WireType.Varint).int32(message.preparedById);
        /* int32 lost_threshold_days = 5; */
        if (message.lostThresholdDays !== 0)
            writer.tag(5, WireType.Varint).int32(message.lostThresholdDays);
        /* string status = 6; */
        if (message.status !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.status);
        /* int32 page_number = 7; */
        if (message.pageNumber !== 0)
            writer.tag(7, WireType.Varint).int32(message.pageNumber);
        /* int32 page_size = 8; */
        if (message.pageSize !== 0)
            writer.tag(8, WireType.Varint).int32(message.pageSize);
        /* string intake_type = 9; */
        if (message.intakeType !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.intakeType);
        /* string is_lmpc_filter = 10; */
        if (message.isLmpcFilter !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.isLmpcFilter);
        /* int32 tech_user_id = 11; */
        if (message.techUserId !== 0)
            writer.tag(11, WireType.Varint).int32(message.techUserId);
        /* bool priority_sort = 12; */
        if (message.prioritySort !== false)
            writer.tag(12, WireType.Varint).bool(message.prioritySort);
        /* repeated int32 department_ids = 13; */
        if (message.departmentIds.length) {
            writer.tag(13, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.departmentIds.length; i++)
                writer.int32(message.departmentIds[i]);
            writer.join();
        }
        /* repeated int32 prepared_by_ids = 14; */
        if (message.preparedByIds.length) {
            writer.tag(14, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.preparedByIds.length; i++)
                writer.int32(message.preparedByIds[i]);
            writer.join();
        }
        /* repeated int32 tech_user_ids = 15; */
        if (message.techUserIds.length) {
            writer.tag(15, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.techUserIds.length; i++)
                writer.int32(message.techUserIds[i]);
            writer.join();
        }
        /* repeated int32 assigned_admin_user_ids = 16; */
        if (message.assignedAdminUserIds.length) {
            writer.tag(16, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.assignedAdminUserIds.length; i++)
                writer.int32(message.assignedAdminUserIds[i]);
            writer.join();
        }
        /* int32 sector = 17; */
        if (message.sector !== 0)
            writer.tag(17, WireType.Varint).int32(message.sector);
        /* string search = 18; */
        if (message.search !== "")
            writer.tag(18, WireType.LengthDelimited).string(message.search);
        /* string job_status = 19; */
        if (message.jobStatus !== "")
            writer.tag(19, WireType.LengthDelimited).string(message.jobStatus);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProposalsByStatusRequest
 */
export const ProposalsByStatusRequest = new ProposalsByStatusRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProposalsByStatusResponse$Type extends MessageType {
    constructor() {
        super("ProposalsByStatusResponse", [
            { no: 1, name: "proposals", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ProposalDetail },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.proposals = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ProposalDetail proposals */ 1:
                    message.proposals.push(ProposalDetail.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated ProposalDetail proposals = 1; */
        for (let i = 0; i < message.proposals.length; i++)
            ProposalDetail.internalBinaryWrite(message.proposals[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProposalsByStatusResponse
 */
export const ProposalsByStatusResponse = new ProposalsByStatusResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProposalDetail$Type extends MessageType {
    constructor() {
        super("ProposalDetail", [
            { no: 1, name: "quote_document_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "quote_sent_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "signed_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "prepared_by_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "job_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "proposal_amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 9, name: "status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "property_address", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "customer_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "lost_reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "intake_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "is_lmpc", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 15, name: "priority", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 16, name: "submitter_user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 17, name: "tracking_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "assigned_admin_user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 19, name: "reminder_sent_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 20, name: "customer_viewed_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.quoteDocumentId = 0;
        message.eventId = 0;
        message.quoteSentDate = "";
        message.signedDate = "";
        message.preparedById = 0;
        message.departmentId = 0;
        message.jobStatus = "";
        message.proposalAmount = 0;
        message.status = "";
        message.propertyAddress = "";
        message.customerName = "";
        message.lostReason = "";
        message.intakeType = "";
        message.isLmpc = false;
        message.priority = false;
        message.submitterUserId = 0;
        message.trackingNumber = "";
        message.assignedAdminUserId = 0;
        message.reminderSentDate = "";
        message.customerViewedDate = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 quote_document_id */ 1:
                    message.quoteDocumentId = reader.int32();
                    break;
                case /* int32 event_id */ 2:
                    message.eventId = reader.int32();
                    break;
                case /* string quote_sent_date */ 3:
                    message.quoteSentDate = reader.string();
                    break;
                case /* string signed_date */ 4:
                    message.signedDate = reader.string();
                    break;
                case /* int32 prepared_by_id */ 5:
                    message.preparedById = reader.int32();
                    break;
                case /* int32 department_id */ 6:
                    message.departmentId = reader.int32();
                    break;
                case /* string job_status */ 7:
                    message.jobStatus = reader.string();
                    break;
                case /* double proposal_amount */ 8:
                    message.proposalAmount = reader.double();
                    break;
                case /* string status */ 9:
                    message.status = reader.string();
                    break;
                case /* string property_address */ 10:
                    message.propertyAddress = reader.string();
                    break;
                case /* string customer_name */ 11:
                    message.customerName = reader.string();
                    break;
                case /* string lost_reason */ 12:
                    message.lostReason = reader.string();
                    break;
                case /* string intake_type */ 13:
                    message.intakeType = reader.string();
                    break;
                case /* bool is_lmpc */ 14:
                    message.isLmpc = reader.bool();
                    break;
                case /* bool priority */ 15:
                    message.priority = reader.bool();
                    break;
                case /* int32 submitter_user_id */ 16:
                    message.submitterUserId = reader.int32();
                    break;
                case /* string tracking_number */ 17:
                    message.trackingNumber = reader.string();
                    break;
                case /* int32 assigned_admin_user_id */ 18:
                    message.assignedAdminUserId = reader.int32();
                    break;
                case /* string reminder_sent_date */ 19:
                    message.reminderSentDate = reader.string();
                    break;
                case /* string customer_viewed_date */ 20:
                    message.customerViewedDate = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 quote_document_id = 1; */
        if (message.quoteDocumentId !== 0)
            writer.tag(1, WireType.Varint).int32(message.quoteDocumentId);
        /* int32 event_id = 2; */
        if (message.eventId !== 0)
            writer.tag(2, WireType.Varint).int32(message.eventId);
        /* string quote_sent_date = 3; */
        if (message.quoteSentDate !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.quoteSentDate);
        /* string signed_date = 4; */
        if (message.signedDate !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.signedDate);
        /* int32 prepared_by_id = 5; */
        if (message.preparedById !== 0)
            writer.tag(5, WireType.Varint).int32(message.preparedById);
        /* int32 department_id = 6; */
        if (message.departmentId !== 0)
            writer.tag(6, WireType.Varint).int32(message.departmentId);
        /* string job_status = 7; */
        if (message.jobStatus !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.jobStatus);
        /* double proposal_amount = 8; */
        if (message.proposalAmount !== 0)
            writer.tag(8, WireType.Bit64).double(message.proposalAmount);
        /* string status = 9; */
        if (message.status !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.status);
        /* string property_address = 10; */
        if (message.propertyAddress !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.propertyAddress);
        /* string customer_name = 11; */
        if (message.customerName !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.customerName);
        /* string lost_reason = 12; */
        if (message.lostReason !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.lostReason);
        /* string intake_type = 13; */
        if (message.intakeType !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.intakeType);
        /* bool is_lmpc = 14; */
        if (message.isLmpc !== false)
            writer.tag(14, WireType.Varint).bool(message.isLmpc);
        /* bool priority = 15; */
        if (message.priority !== false)
            writer.tag(15, WireType.Varint).bool(message.priority);
        /* int32 submitter_user_id = 16; */
        if (message.submitterUserId !== 0)
            writer.tag(16, WireType.Varint).int32(message.submitterUserId);
        /* string tracking_number = 17; */
        if (message.trackingNumber !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.trackingNumber);
        /* int32 assigned_admin_user_id = 18; */
        if (message.assignedAdminUserId !== 0)
            writer.tag(18, WireType.Varint).int32(message.assignedAdminUserId);
        /* string reminder_sent_date = 19; */
        if (message.reminderSentDate !== "")
            writer.tag(19, WireType.LengthDelimited).string(message.reminderSentDate);
        /* string customer_viewed_date = 20; */
        if (message.customerViewedDate !== "")
            writer.tag(20, WireType.LengthDelimited).string(message.customerViewedDate);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProposalDetail
 */
export const ProposalDetail = new ProposalDetail$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QuoteDocumentProposal$Type extends MessageType {
    constructor() {
        super("QuoteDocumentProposal", [
            { no: 1, name: "quote_document", kind: "message", T: () => QuoteDocument },
            { no: 2, name: "lines", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => QuoteLine },
            { no: 3, name: "total_amount", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.lines = [];
        message.totalAmount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* QuoteDocument quote_document */ 1:
                    message.quoteDocument = QuoteDocument.internalBinaryRead(reader, reader.uint32(), options, message.quoteDocument);
                    break;
                case /* repeated QuoteLine lines */ 2:
                    message.lines.push(QuoteLine.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* float total_amount */ 3:
                    message.totalAmount = reader.float();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* QuoteDocument quote_document = 1; */
        if (message.quoteDocument)
            QuoteDocument.internalBinaryWrite(message.quoteDocument, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated QuoteLine lines = 2; */
        for (let i = 0; i < message.lines.length; i++)
            QuoteLine.internalBinaryWrite(message.lines[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* float total_amount = 3; */
        if (message.totalAmount !== 0)
            writer.tag(3, WireType.Bit32).float(message.totalAmount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QuoteDocumentProposal
 */
export const QuoteDocumentProposal = new QuoteDocumentProposal$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QuoteDocumentProposalList$Type extends MessageType {
    constructor() {
        super("QuoteDocumentProposalList", [
            { no: 1, name: "proposals", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => QuoteDocumentProposal },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.proposals = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated QuoteDocumentProposal proposals */ 1:
                    message.proposals.push(QuoteDocumentProposal.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated QuoteDocumentProposal proposals = 1; */
        for (let i = 0; i < message.proposals.length; i++)
            QuoteDocumentProposal.internalBinaryWrite(message.proposals[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QuoteDocumentProposalList
 */
export const QuoteDocumentProposalList = new QuoteDocumentProposalList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SellSheet$Type extends MessageType {
    constructor() {
        super("SellSheet", [
            { no: 1, name: "file_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "document_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "property_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "customer_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "document_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "creator", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 13, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 15, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 17, name: "not_equals", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 19, name: "date_range", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 20, name: "date_target", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 21, name: "event_id_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.fileId = 0;
        message.documentId = 0;
        message.eventId = 0;
        message.propertyId = 0;
        message.customerId = 0;
        message.documentDate = "";
        message.creator = 0;
        message.fieldMask = [];
        message.pageNumber = 0;
        message.orderBy = "";
        message.orderDir = "";
        message.notEquals = [];
        message.withoutLimit = false;
        message.dateRange = [];
        message.dateTarget = [];
        message.eventIdList = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 file_id */ 1:
                    message.fileId = reader.int32();
                    break;
                case /* int32 document_id */ 2:
                    message.documentId = reader.int32();
                    break;
                case /* int32 event_id */ 3:
                    message.eventId = reader.int32();
                    break;
                case /* int32 property_id */ 4:
                    message.propertyId = reader.int32();
                    break;
                case /* int32 customer_id */ 5:
                    message.customerId = reader.int32();
                    break;
                case /* string document_date */ 6:
                    message.documentDate = reader.string();
                    break;
                case /* int32 creator */ 7:
                    message.creator = reader.int32();
                    break;
                case /* repeated string field_mask */ 13:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 14:
                    message.pageNumber = reader.int32();
                    break;
                case /* string order_by */ 15:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 16:
                    message.orderDir = reader.string();
                    break;
                case /* repeated string not_equals */ 17:
                    message.notEquals.push(reader.string());
                    break;
                case /* bool without_limit */ 18:
                    message.withoutLimit = reader.bool();
                    break;
                case /* repeated string date_range */ 19:
                    message.dateRange.push(reader.string());
                    break;
                case /* repeated string date_target */ 20:
                    message.dateTarget.push(reader.string());
                    break;
                case /* string event_id_list */ 21:
                    message.eventIdList = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 file_id = 1; */
        if (message.fileId !== 0)
            writer.tag(1, WireType.Varint).int32(message.fileId);
        /* int32 document_id = 2; */
        if (message.documentId !== 0)
            writer.tag(2, WireType.Varint).int32(message.documentId);
        /* int32 event_id = 3; */
        if (message.eventId !== 0)
            writer.tag(3, WireType.Varint).int32(message.eventId);
        /* int32 property_id = 4; */
        if (message.propertyId !== 0)
            writer.tag(4, WireType.Varint).int32(message.propertyId);
        /* int32 customer_id = 5; */
        if (message.customerId !== 0)
            writer.tag(5, WireType.Varint).int32(message.customerId);
        /* string document_date = 6; */
        if (message.documentDate !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.documentDate);
        /* int32 creator = 7; */
        if (message.creator !== 0)
            writer.tag(7, WireType.Varint).int32(message.creator);
        /* repeated string field_mask = 13; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(13, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 14; */
        if (message.pageNumber !== 0)
            writer.tag(14, WireType.Varint).int32(message.pageNumber);
        /* string order_by = 15; */
        if (message.orderBy !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 16; */
        if (message.orderDir !== "")
            writer.tag(16, WireType.LengthDelimited).string(message.orderDir);
        /* repeated string not_equals = 17; */
        for (let i = 0; i < message.notEquals.length; i++)
            writer.tag(17, WireType.LengthDelimited).string(message.notEquals[i]);
        /* bool without_limit = 18; */
        if (message.withoutLimit !== false)
            writer.tag(18, WireType.Varint).bool(message.withoutLimit);
        /* repeated string date_range = 19; */
        for (let i = 0; i < message.dateRange.length; i++)
            writer.tag(19, WireType.LengthDelimited).string(message.dateRange[i]);
        /* repeated string date_target = 20; */
        for (let i = 0; i < message.dateTarget.length; i++)
            writer.tag(20, WireType.LengthDelimited).string(message.dateTarget[i]);
        /* string event_id_list = 21; */
        if (message.eventIdList !== "")
            writer.tag(21, WireType.LengthDelimited).string(message.eventIdList);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SellSheet
 */
export const SellSheet = new SellSheet$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SellSheetList$Type extends MessageType {
    constructor() {
        super("SellSheetList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SellSheet },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated SellSheet results */ 1:
                    message.results.push(SellSheet.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated SellSheet results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SellSheet.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SellSheetList
 */
export const SellSheetList = new SellSheetList$Type();
/**
 * @generated ServiceType for protobuf service QuoteService
 */
export const QuoteService = new ServiceType("QuoteService", [
    { name: "Create", options: {}, I: Quote, O: Quote },
    { name: "Get", options: {}, I: Quote, O: Quote },
    { name: "BatchGet", options: {}, I: Quote, O: QuoteList },
    { name: "Update", options: {}, I: Quote, O: Quote },
    { name: "Delete", options: {}, I: Quote, O: Quote },
    { name: "GetProposalMetrics", options: {}, I: ProposalMetricsRequest, O: ProposalMetricsResponse },
    { name: "GetProposalsByStatus", options: {}, I: ProposalsByStatusRequest, O: ProposalsByStatusResponse },
    { name: "CreateQuoteUsed", options: {}, I: QuoteUsed, O: QuoteUsed },
    { name: "GetQuoteUsed", options: {}, I: QuoteUsed, O: QuoteUsed },
    { name: "BatchGetQuoteUsed", options: {}, I: QuoteUsed, O: QuoteUsedList },
    { name: "UpdateQuoteUsed", options: {}, I: QuoteUsed, O: QuoteUsed },
    { name: "DeleteQuoteUsed", options: {}, I: QuoteUsed, O: QuoteUsed },
    { name: "CreateQuotePart", options: {}, I: QuotePart, O: QuotePart },
    { name: "GetQuotePart", options: {}, I: QuotePart, O: QuotePart },
    { name: "BatchGetQuotePart", options: {}, I: QuotePart, O: QuotePartList },
    { name: "UpdateQuotePart", options: {}, I: QuotePart, O: QuotePart },
    { name: "DeleteQuotePart", options: {}, I: QuotePart, O: QuotePart },
    { name: "CreateQuoteLine", options: {}, I: QuoteLine, O: QuoteLine },
    { name: "GetQuoteLine", options: {}, I: QuoteLine, O: QuoteLine },
    { name: "BatchGetQuoteLine", options: {}, I: QuoteLine, O: QuoteLineList },
    { name: "UpdateQuoteLine", options: {}, I: QuoteLine, O: QuoteLine },
    { name: "DeleteQuoteLine", options: {}, I: QuoteLine, O: QuoteLine },
    { name: "CreateQuoteLinePart", options: {}, I: QuoteLinePart, O: QuoteLinePart },
    { name: "GetQuoteLinePart", options: {}, I: QuoteLinePart, O: QuoteLinePart },
    { name: "BatchGetQuoteLinePart", options: {}, I: QuoteLinePart, O: QuoteLinePartList },
    { name: "UpdateQuoteLinePart", options: {}, I: QuoteLinePart, O: QuoteLinePart },
    { name: "DeleteQuoteLinePart", options: {}, I: QuoteLinePart, O: QuoteLinePart },
    { name: "CreateQuoteDocument", options: {}, I: QuoteDocument, O: QuoteDocument },
    { name: "GetQuoteDocument", options: {}, I: QuoteDocument, O: QuoteDocument },
    { name: "BatchGetQuoteDocument", options: {}, I: QuoteDocument, O: QuoteDocumentList },
    { name: "UpdateQuoteDocument", options: {}, I: QuoteDocument, O: QuoteDocument },
    { name: "DeleteQuoteDocument", options: {}, I: QuoteDocument, O: QuoteDocument },
    { name: "CreateStoredQuote", options: {}, I: StoredQuote, O: StoredQuote },
    { name: "GetStoredQuote", options: {}, I: StoredQuote, O: StoredQuote },
    { name: "BatchGetStoredQuote", options: {}, I: StoredQuote, O: StoredQuoteList },
    { name: "UpdateStoredQuote", options: {}, I: StoredQuote, O: StoredQuote },
    { name: "DeleteStoredQuote", options: {}, I: StoredQuote, O: StoredQuote },
    { name: "GetQuotePhoto", options: {}, I: QuotePhoto, O: QuotePhoto },
    { name: "CreateQuotePhoto", options: {}, I: QuotePhoto, O: QuotePhoto },
    { name: "BatchGetQuotePhoto", options: {}, I: QuotePhoto, O: QuotePhotoList },
    { name: "UpdateQuotePhoto", options: {}, I: QuotePhoto, O: QuotePhoto },
    { name: "DeleteQuotePhoto", options: {}, I: QuotePhoto, O: QuotePhoto },
    { name: "GetQuoteUsedPhoto", options: {}, I: QuoteUsedPhoto, O: QuoteUsedPhoto },
    { name: "CreateQuoteUsedPhoto", options: {}, I: QuoteUsedPhoto, O: QuoteUsedPhoto },
    { name: "BatchGetQuoteUsedPhoto", options: {}, I: QuoteUsedPhoto, O: QuoteUsedPhotoList },
    { name: "UpdateQuoteUsedPhoto", options: {}, I: QuoteUsedPhoto, O: QuoteUsedPhoto },
    { name: "DeleteQuoteUsedPhoto", options: {}, I: QuoteUsedPhoto, O: QuoteUsedPhoto },
    { name: "BatchGetQuoteDocumentProposal", options: {}, I: QuoteDocument, O: QuoteDocumentProposalList },
    { name: "GetSellSheet", options: {}, I: SellSheet, O: SellSheet },
    { name: "BatchGetSellSheet", options: {}, I: SellSheet, O: SellSheetList }
]);
